var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgContactsIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 22,
    viewBox: "0 0 20 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.2112 1.52734H6.21147C4.11867 1.52734 2.42212 3.22385 2.42212 5.31659V16.6843C2.42212 18.7771 4.11867 20.4736 6.21147 20.4736H15.2112C17.304 20.4736 19.0005 18.7771 19.0005 16.6843V5.31659C19.0005 3.22385 17.304 1.52734 15.2112 1.52734Z",
    stroke: "white",
    strokeWidth: 1.3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M8.66396 12.6486C8.06809 13.0484 6.50688 13.8631 7.458 14.8824C7.9222 15.3807 8.44039 15.7368 9.09027 15.7368H12.8038C13.4537 15.7368 13.9719 15.3807 14.4361 14.8824C15.3872 13.8631 13.826 13.0484 13.2301 12.6496C12.5566 12.1922 11.7612 11.9477 10.947 11.9477C10.1329 11.9477 9.33751 12.1922 8.66396 12.6496M3.36834 5.31641H1M3.36834 11.0003H1M3.36834 16.6842H1M12.8417 8.15834C12.8417 8.66083 12.6421 9.14274 12.2868 9.49805C11.9315 9.85336 11.4495 10.053 10.947 10.053C10.4445 10.053 9.96263 9.85336 9.60731 9.49805C9.25199 9.14274 9.05237 8.66083 9.05237 8.15834C9.05237 7.65586 9.25199 7.17395 9.60731 6.81864C9.96263 6.46333 10.4445 6.26372 10.947 6.26372C11.4495 6.26372 11.9315 6.46333 12.2868 6.81864C12.6421 7.17395 12.8417 7.65586 12.8417 8.15834Z",
    stroke: "white",
    strokeWidth: 1.3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgContactsIcon);
export default __webpack_public_path__ + "static/media/contacts-icon.41d47495927aa69e71cec31bfde178b1.svg";
export { ForwardRef as ReactComponent };